import { createRoot } from 'react-dom/client';

import { assertRuntimeEnv, validateRuntimeEnv } from '../lib/env';
import { getDeploySurface } from '../lib/deploySurface';
import { initWebVitals } from './services/webVitals';
import SurfaceApp from './SurfaceApp';

const rootElement = document.getElementById('root');

const renderStartupConfigError = () => {
  if (!rootElement) return;

  const validation = validateRuntimeEnv();

  const container = document.createElement('main');
  container.style.cssText = 'font-family: Inter, system-ui, sans-serif; padding: 24px; max-width: 760px; margin: 24px auto; color: #f8fafc; background: #0f172a; border-radius: 12px; border: 1px solid rgba(255,255,255,.1);';

  const heading = document.createElement('h1');
  heading.style.cssText = 'font-size: 1.25rem; margin-bottom: 0.75rem;';
  heading.textContent = 'Ninpo Snacks startup configuration error';
  container.appendChild(heading);

  const sub = document.createElement('p');
  sub.style.cssText = 'opacity: .9; margin-bottom: 0.75rem;';
  sub.textContent = 'The app cannot boot because runtime environment variables are missing or invalid.';
  container.appendChild(sub);

  const list = document.createElement('ul');
  list.style.cssText = 'line-height: 1.6; margin-left: 1rem;';
  validation.issues.forEach((issue) => {
    const item = document.createElement('li');
    const strong = document.createElement('strong');
    strong.textContent = issue.key;
    item.appendChild(strong);
    item.appendChild(document.createTextNode(`: ${issue.message}`));
    list.appendChild(item);
  });
  container.appendChild(list);

  rootElement.replaceChildren(container);
};

export function mountSurfaceApp(): void {
  if (!rootElement) return;
  try {
    assertRuntimeEnv();
    createRoot(rootElement).render(<SurfaceApp surface={getDeploySurface()} />);
    initWebVitals();
  } catch (error) {
    console.error(error);
    renderStartupConfigError();
  }
}
